/**
 * 2007-2018 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2018 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
// import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';

// import touchevents from './lib/touchevents';

// + user
import 'double-add-to-cart-click-protection';
import WindowResizer from 'window-resizer';
import StickyMenu from 'sticky-menu';
import MainMenu from 'main-menu';
// import FacetedFullWidth from 'faceted-full-width';
import JumpOutOfContainer from 'jump-out-of-container';
import Theme from 'theme';
// - user

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);
  // let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  // productMinitature.init();
  productSelect.init();
  
  // const isTouch = touchevents();
  
  setTimeout(() => {
    
    console.log( 'theme.js' );
    
    let xWindowResizer = new WindowResizer();
    
    let xStickyMenu = new StickyMenu({
      el: '.top-nav',
      // togglerHtml: '<div class="sticky-menu-toggler"><div class="container"><a class="sticky-menu-cart" rel="nofollow" href="' + prestashop.urls.pages.cart + '?action=show"><i class="fas fa-shopping-cart"></i></a><a href="javascript:void(0)" class="sticky-menu-toggler-button"><i class="fas fa-long-arrow-alt-down"></i><i class="fas fa-long-arrow-alt-down"></i><i class="fas fa-long-arrow-alt-down"></i></a></div></div>',
      togglerHtml: `
        <div class="sticky-menu-toggler">
          <div class="container">
            <a class="sticky-menu-cart" rel="nofollow" href="${prestashop.urls.pages.cart}?action=show">
              <i class="fas fa-shopping-cart"></i>
            </a>
            <a href="javascript:void(0)" class="sticky-menu-toggler-button">
              <div style="text-align: center; color: red;"><i class="fas fa-chevron-down"></i></div>
              <div style="font-size: 10px;">ROZWIŃ</div>
            </a>
          </div>
        </div>
      `,
    });
    
    xStickyMenu.init();
    
    let xMainMenu = new MainMenu();
    xMainMenu.init();
    
    // let xFacetedFullWidth = new FacetedFullWidth();
    // xFacetedFullWidth.init();
    
    let xJumpOutOfContainer = new JumpOutOfContainer();
    xJumpOutOfContainer.init();
    
    let xTheme = new Theme();
    xTheme.init();
    
    xWindowResizer.addEvent(xStickyMenu.onWindowResize, xStickyMenu);
    xWindowResizer.addEvent(xMainMenu.onWindowResize, xMainMenu);
    xWindowResizer.addEvent(xJumpOutOfContainer.onWindowResize, xJumpOutOfContainer);
    xWindowResizer.addEvent(xTheme.onWindowResize, xTheme);
    
    xWindowResizer.init();
  
  }, 1);
  
});



// WEBPACK FOOTER //
// ./js/theme.js